import { t } from "i18next";
import * as yup from "yup";

export const recoverPasswordSchema = () => {
  return yup.object().shape({
    email: yup
      .string()
      .min(3, " ")
      .max(50, " ")
      .email(t("form.error.email.emailForm2")!)
      .required(t("form.error.email.required2")!),
  });
};
